<template>
  <div class="exception">
    <div class="img">
      <img :src="config[type].img">
    </div>
    <div class="content">
      <h1 class="desc">{{ config[type].desc }}</h1>
      <div class="action">
        <a-button @click="handleToHome">重新加载</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import types from './type'

export default {
  name: 'Exception',
  props: {
    type: {
      type: String,
      default: '404'
    }
  },
  data () {
    return {
      config: types
    }
  },
  methods: {
    handleToHome () {
      this.$router.go(0)
    }
  }
}
</script>

<style lang="scss" scoped>
.exception {
  height: 100%;
  text-align: center;
  padding-top: 150px;
  box-sizing: border-box;
  .content {
    display: inline-block;
    // flex: auto;
    h1 {
      color: #434e59;
      font-size: 72px;
      font-weight: 600;
      line-height: 72px;
      margin-bottom: 24px;
    }
    .desc {
      color: rgba(0, 0, 0, 0.45);
      font-size: 20px;
      margin: 25px 0;
    }
  }
}

.mobile {
  .exception {
    margin-top: 30px;
    .img {
      padding-right: unset;

      img {
        height: 40%;
        max-width: 80%;
      }
    }
  }
}
</style>
